import SectionHeader from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import { SectionLayoutProps } from "./SectionLayout.constants";
import VariantWrapper from "./VariantWrapper";
import SectionMedia from "./SectionMedia";

function SectionLayoutVariant6(props: SectionLayoutProps) {
    const {
        headerSettings,
        section,
        isEntrySection
    } = props;
    const { media } = section;

    return (
        <VariantWrapper section={section}>
            <TextWrapper
                style={{ color: 'white' }}
                initial={isEntrySection}
            >
                <SectionHeader {...headerSettings} />
            </TextWrapper>

            <SectionMedia
                style={{ position: 'absolute', zIndex: -10, filter: 'brightness(0.8)' }}
                media={media}
            />
        </VariantWrapper>
    )
}

export default SectionLayoutVariant6;
